import { Domain } from '../domains/domain';

export class ComplaintStatus {
  public id?: string;
  public name: string;
  public domain?: Domain;
}
